import React from 'react';
import { Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface ConnectorProps {
  onClick?: () => void;
}

export default function StageConnector({ onClick }: ConnectorProps) {
  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        width: '2px',
        flexGrow: 1,
        mx: 'auto',
        backgroundColor: theme.custom?.textLight || '#A2ABB1',
        minHeight: '60px',
        display: 'flex',
        justifyContent: 'center',
      })}
    >
      <Box
        sx={(theme) => ({
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: theme.custom?.textLight || '#A2ABB1',
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        })}
      />

      <Box
        sx={(theme) => ({
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: theme.custom?.textLight || '#A2ABB1',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        })}
      />

      {/* Hover circle with plus */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0,
          transition: 'opacity 0.2s ease',
          '&:hover': {
            opacity: 1,
          },
        }}
      >
        <IconButton
          size="small"
          onClick={onClick}
          sx={(theme) => ({
            bgcolor: theme.custom?.background1,
            border: `2px solid ${theme.custom?.primary}`,
            color: theme.custom?.primary,
            '&:hover': {
              bgcolor: theme.custom?.primary,
              color: theme.custom?.textCTA,
            },
          })}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
